import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import LINK from 'constants/link.const';
import { withTranslation } from 'providers/GILT.provider';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromObjectToQueryString from 'utils/converters/object/fromObjectToQueryString.util';
import { fromPropsToQuery, fromPropsToQueryString } from 'utils/converters/props/path.util';
import linkTo from 'utils/links/linkTo.util';
import navFor from 'utils/links/navFor.util';
import asObject from 'utils/objects/asObject.util';
import finishOnboarding from 'utils/salons/finishOnboarding.util';

import PopupModalContainer from 'common/PopupModal';
import HeaderContainer from 'onboarding/common/Header';
import OnboardingFooter from 'onboarding/common/OnboardingFooter';
import { addInitialCategories, addService, deleteService, getCategories } from 'onboarding/services/actions';
import ServicesScreenContainer from 'onboarding/services/ServicesScreen';

class ServicesScreenWrap extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isFooterButtonActive: false,
      errorMessage: '',
      quickPageOne: fromAnyToBool(asObject(this.props.location.state).quick || fromPropsToQuery(this.props).quick === 'true'),
      quickPageTwo: false,
      timerId: null,
    };
  }

  UNSAFE_componentWillMount() {
    if (!this.props.currentSalon) {
      navFor('ServicesScreenWrap.componentWillMount()', this.props).push({
        pathname: LINK.onboardingType,
        search: fromPropsToQueryString(this.props),
      });
    }

    this.checkButton(this.props);
  }

  componentDidMount() {
    this.initPage();
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.isPosting && nextProps.areCategoriesFetched && nextProps.categories.length === 0 && !this.state.quickPageOne && !this.state.quickPageTwo) {
      this.props.addInitialCategories(this.props.currentSalon.id);
    }
    this.checkButton(nextProps);
  }

  onFooterButtonClicked = () => {
    if (!this.state.isFooterButtonActive) {
      return;
    }
    if (this.state.timerId) {
      clearTimeout(this.state.timerId);
    }

    if (this.state.quickPageOne) {
      this.setState({ quickPageOne: false, quickPageTwo: true });
      this.initPage();
    } else {
      const { cognitoUser, currentSalon } = this.props;

      if (this.state.quickPageTwo) {
        finishOnboarding({ cognitoUser })
          .then(() => {
            const query = fromPropsToQuery(this.props);
            const salonId = asObject(currentSalon).id || query.salonId;
            navFor('ServicesScreenWrap.onFooterButtonClicked()', 'updateAttributes().then()', this.props).push({
              pathname: linkTo({
                pattern: LINK.scheduleDay,
                params: { salonId, dateString: 'today' },
              }),
              search: fromObjectToQueryString(query),
            });
          })
          .catch((e) => void this.setState({ errorMessage: e.message || JSON.stringify(e) }));
      } else {
        navFor('ServicesScreenWrap.componentWillMount()', this.props).push({
          pathname: LINK.onboardingStylists,
          search: fromPropsToQueryString(this.props),
        });
      }
    }
  };

  onEditClick = (service, category) => {
    const serviceId = asObject(service).id;
    const categoryId = asObject(category).id;

    navFor('ServicesScreenWrap.onEditClick()', this.props).push({
      pathname: LINK.onboardingAddService,
      state: { category, service },
      search: fromObjectToQueryString({ ...fromPropsToQuery(this.props), categoryId, serviceId }),
    });
  };

  onDeleteClick = (id) => void this.props.deleteService(this.props.currentSalon.id, id);

  onAddNewService = (service, category) => void this.props.addService(service, category.id, this.props.currentSalon.id);

  initPage = () => {
    window.scrollTo(0, 0);

    if (this.state.quickPageOne || this.state.quickPageTwo) {
      const timerId = setTimeout(() => void this.onFooterButtonClicked(), 8000);
      this.setState({ timerId });
    }
  };

  navigateToAddService = (category) => {
    const categoryId = asObject(category).id;
    navFor('ServicesScreenWrap.navigateToAddService()', this.props).push({
      pathname: LINK.onboardingAddService,
      state: { category },
      search: fromObjectToQueryString({ ...fromPropsToQuery(this.props), categoryId }),
    });
  };

  checkButton = (props) => {
    const { quickPageOne, quickPageTwo } = this.state;

    // If it is quick layout always active
    if (quickPageOne || quickPageTwo) {
      this.setState({ isFooterButtonActive: true });
      return;
    }

    // If not quick layout do the old logic
    if (!props.categories) {
      return;
    }

    for (let i = 0; i < props.categories.length; i += 1) {
      if (props.categories[i].services && props.categories[i].services.length > 0) {
        this.setState({ isFooterButtonActive: true });
        return;
      }
    }

    this.setState({ isFooterButtonActive: false });
  };

  editCategoryClicked = (category) =>
    void navFor('ServicesScreenWrap.editCategoryClicked()', this.props).push({
      pathname: LINK.onboardingEditCategory,
      state: { category },
    });

  hideError = () => void this.setState({ errorMessage: '' });

  render() {
    const { isFooterButtonActive, quickPageOne, errorMessage, quickPageTwo } = this.state;
    const { isFetching, isPosting, t } = this.props;

    // eslint-disable-next-line no-nested-ternary
    const title = quickPageTwo ? t('register.servicesScreenWrap.title1') : quickPageOne ? t('register.servicesScreenWrap.title2') : t('register.servicesScreenWrap.title3');

    // eslint-disable-next-line no-nested-ternary
    const description = quickPageTwo ? t('register.servicesScreenWrap.description1') : quickPageOne ? t('register.servicesScreenWrap.description2') : t('register.servicesScreenWrap.description3');

    return (
      <div data-bem="ServicesScreenWrap" className="content-wrap onboarding-stylist">
        {errorMessage && <PopupModalContainer popupTitle={t('common.error')} popupMessage={errorMessage} buttonText={t('common.buttons.okay')} buttonCallback={this.hideError} />}

        <HeaderContainer
          titleFirstPart={title}
          description={description}
          backBtnCallBack={() => {
            if (quickPageOne) {
              const state = { quick: true };
              navFor('ServicesScreenWrap.render()', 'backBtnCallBack()', this.props).push({
                pathname: LINK.onboardingStylists,
                state,
                search: fromObjectToQueryString({ ...fromPropsToQuery(this.props), ...state }),
              });
            } else if (quickPageTwo) {
              this.setState({ quickPageOne: true, quickPageTwo: false });
            } else {
              navFor('ServicesScreenWrap.render()', 'backBtnCallBack()', this.props).push({
                pathname: LINK.onboardingCategories,
                search: fromPropsToQueryString(this.props),
              });
            }
          }}
        />

        <ServicesScreenContainer
          navigateToAddService={this.navigateToAddService}
          onEdit={this.onEditClick}
          onDelete={this.onDeleteClick}
          editCategoryClicked={this.editCategoryClicked}
          quickSetupLayoutPageOne={quickPageOne}
          quickSetupLayoutPageTwo={quickPageTwo}
          onAddNewService={this.onAddNewService}
        />

        <OnboardingFooter isFooterButtonActive={isFooterButtonActive} onButtonClick={this.onFooterButtonClicked} isLoading={isFetching || isPosting} />

        {(isPosting || isFetching) && <div data-bem="ServicesScreenWrap__load-blocker" className="load-blocker" />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  cognitoUser: state.cognito.user,
  currentSalon: state.currentSalon,
  categories: state.onboarding.services.categories,
  areCategoriesFetched: state.onboarding.services.areCategoriesFetched,
  isFetching: state.onboarding.services.isFetching,
  isPosting: state.onboarding.services.isPosting,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCategories,
      addInitialCategories,
      deleteService,
      addService,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ServicesScreenWrap));
